import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n'], ['\n  display: flex;\n']);

import styled from 'styled-components';

var NavigationItemAfterWrapper = styled.div(_templateObject);

NavigationItemAfterWrapper.displayName = 'NavigationItemAfterWrapper';
export default NavigationItemAfterWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/NavigationItemAfterWrapper.js
// module id = 634
// module chunks = 0